export interface IConsent {
  consentId: string;
  consentedOn: string;
}

export enum USER_CONSENT_FIELDS {
  CONSENT_ID = 'consentId',
  CONSENTED_ON = 'consentedOn',
}
